import { Box, Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import BuzzModal from '../../../components/BuzzModal/BuzzModal';
import useLoader from '../../../hooks/useLoader';
import useToast from '../../../hooks/useToast';
import moment from 'moment';
import {
  commonApprovalAsync,
  getApprovalListAsync,
  // getUserDetailsAsync,
} from '../ApprovalStore/approvalSlice';
import { useDispatch, useSelector } from 'react-redux';

const DiscoveryApprovalModal = ({ open = false, onClose = '' }) => {
  const { handleLoader } = useLoader();
  const { SuccessToast, ErrorToast } = useToast();
  const dispatch = useDispatch();
  const [userReview, setUserReview] = useState(null);

  const { reviewApprovalDetails, reviewDetails } = useSelector(
    ({ approvalReducer }) => {
      return {
        reviewApprovalDetails: approvalReducer.commonOneApprovalDetails,
        reviewDetails: approvalReducer.reviewDetails,
      };
    }
  );

  useEffect(() => {
    if (reviewDetails) {
      setUserReview(reviewDetails);
    } else {
      setUserReview(null);
    }
  }, [reviewDetails]);

  const handleApprove = () => {
    handleLoader(true);
    dispatch(
      commonApprovalAsync({
        _id: reviewApprovalDetails._id,
        bodyData: { action: 'approve' },
      })
    )
      .unwrap()
      .then(() => {
        dispatch(
          getApprovalListAsync({
            params: {
              entityType: 'review',
              approvalType: 'review-status',
              limit: 10,
              page: 1,
              statuses: ['pending'],
            },
            type: 'common',
          })
        );
        SuccessToast('Approved!');
      })
      .catch((error) => {
        ErrorToast(error.message);
      })
      .finally(() => {
        handleLoader(false);
        onClose();
      });
  };

  const handleDisapprove = () => {
    handleLoader(true);
    dispatch(
      commonApprovalAsync({
        _id: reviewApprovalDetails._id,
        bodyData: { action: 'disapprove' },
      })
    )
      .unwrap()
      .then(() => {
        dispatch(
          getApprovalListAsync({
            params: {
              entityType: 'review',
              approvalType: 'review-status',
              limit: 10,
              page: 1,
              statuses: ['pending'],
            },
            type: 'common',
          })
        );
        SuccessToast('Disapproved!');
      })
      .catch((error) => {
        ErrorToast(error.message);
      })
      .finally(() => {
        handleLoader(false);
        onClose();
      });
  };

  return (
    <BuzzModal
      width={'80vw'}
      open={open}
      title={`Review Details`}
      onClose={onClose}>
      <Box
        fontFamily={'Rubik'}
        display="flex"
        flexDirection={'column'}
        justifyContent="space-between"
        minHeight={'50vh'}>
        <Box>
          <Box
            fontSize={20}
            fontWeight="fontWeightMedium"
            sx={{ textDecoration: 'underline' }}
            mb={1}>
            Review
          </Box>
          {
            <>
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  Review:
                </Box>
                <Box fontSize={16}>{userReview && userReview.review}</Box>
              </Box>
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  Rating:
                </Box>
                <Box fontSize={16}>{userReview && userReview.rating}</Box>
              </Box>
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  Status:
                </Box>
                <Box fontSize={16}>{userReview && userReview.status}</Box>
              </Box>
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  Created at:
                </Box>
                <Box fontSize={16}>
                  {userReview &&
                    moment(userReview.createdAt).format('MMMM Do, YYYY')}
                </Box>
              </Box>
              <Box mb={2} display={'flex'}>
                <Box fontSize={16} mr={1} fontWeight="fontWeightMedium">
                  Updated at:
                </Box>
                <Box fontSize={16}>
                  {userReview &&
                    moment(userReview.updatedAt).format('MMMM Do, YYYY')}
                </Box>
              </Box>
            </>
          }
        </Box>
        <Box
          borderTop={1}
          borderColor="#dfdfdf"
          pt={3}
          mb={2}
          display="flex"
          alignItems="flex-end"
          justifyContent="flex-end">
          <Box mr={1}>
            <Button
              disabled={
                (reviewApprovalDetails &&
                  reviewApprovalDetails.status === 'approve') ||
                (reviewApprovalDetails &&
                  reviewApprovalDetails.status === 'disapprove')
              }
              mr={1}
              variant="contained"
              color="primary"
              onClick={handleApprove}>
              Approve
            </Button>
          </Box>
          <Button
            disabled={
              (reviewApprovalDetails &&
                reviewApprovalDetails.status === 'approve') ||
              (reviewApprovalDetails &&
                reviewApprovalDetails.status === 'disapprove')
            }
            onClick={() => {
              onClose();
              handleDisapprove();
            }}
            color="primary"
            variant="outlined">
            Disapprove
          </Button>
        </Box>
      </Box>
    </BuzzModal>
  );
};

export default DiscoveryApprovalModal;
